<template>
  <metainfo>
    <template v-slot:title="{ content }">{{ content }}</template>
  </metainfo>

  <component :is="layout">
    <slot />
  </component>
</template>

<script>
import { markRaw, ref, watch } from "vue";
import { useRoute } from "vue-router";
import AppLayoutDefault from "@/layouts/AppLayoutDefault.vue";
import { useMeta } from "vue-meta";

export default {
  name: "AppLayout",
  setup() {
    const route = useRoute();
    const layout = ref();

    const { meta: metaData } = useMeta({
      title: "Whitelabel Market — The NFT Marketplace",
    });

    const getLayout = async (lyt) => {
      const c = await import(`../${lyt}.vue` /* @vite-ignore */);
      return c.default;
    };

    watch(
      () => route.meta,
      async (meta) => {
        if (meta.title) {
          metaData.title = "Whitelabel Market — " + meta.title;
        }

        try {
          layout.value = markRaw(
            (meta.layout && (await getLayout(meta.layout))) || AppLayoutDefault
          );
        } catch (e) {
          console.warn("Use AppLayoutDefault instead", e);
          layout.value = markRaw(AppLayoutDefault);
        }
      },
      { immediate: true }
    );
    return { layout };
  },
};
</script>
